import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import HotspotRegister from './components/HotspotRegister';
import theme from './theme';
import './styles/HotspotRegister.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #FFFFFF 0%, #F5F5F5 100%)',
          display: 'flex',
          alignItems: 'center',
          py: { xs: 2, sm: 4 },
        }}
      >
        <HotspotRegister />
      </Box>
    </ThemeProvider>
  );
}

export default App; 